import React, { useState } from 'react';
import Map from './Map';
import MapSkeleton from './MapSkeleton';
import LocationSearch from './LocationSearch';
import { AlertCircle } from 'lucide-react';
import { useMaps } from '../../contexts/MapsContext';
import { validateMapsConfig } from '../../config/maps';

export default function MapContainer() {
  const [error, setError] = useState<string | null>(null);
  const [center, setCenter] = useState<google.maps.LatLngLiteral | null>(null);
  const { isLoaded } = useMaps();

  const handleError = (err: string) => {
    console.error('Map error:', err);
    setError(err);
  };

  // Validate Maps configuration
  try {
    validateMapsConfig();
  } catch (err) {
    handleError(err instanceof Error ? err.message : 'Maps configuration error');
  }

  const handleLocationSelect = (location: google.maps.LatLngLiteral) => {
    setCenter(location);
  };

  return (
    <div className="space-y-4" role="region" aria-label="BTM Location Map">
      <LocationSearch onLocationSelect={handleLocationSelect} />
      <div className="relative w-full h-[600px]">
        {!isLoaded && !error ? (
          <MapSkeleton aria-hidden={!isLoaded} />
        ) : (
          <Map 
            center={center} 
            onError={handleError} 
            aria-hidden={!isLoaded}
          />
        )}
        {error && (
          <div className="absolute inset-0 bg-gray-800 rounded-lg flex items-center justify-center p-6">
            <div className="text-center">
              <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">Unable to load map</h3>
              <p className="text-gray-400">{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded text-white"
              >
                Retry
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}